var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col items-center"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$router.push({ name: 'applications' })}}},[_vm._v("\n        Go back\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }